module.exports = __webpack_public_path__ + "img/Yettel.2abfded4.png";